import React from 'react';

function StarIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 22.014 21'
      {...props}
    >
      <path
        className='subheader__container__dropdowns-icon'
        d='M21.983 7.974a.645.645 0 00-.521-.439l-6.825-.992L11.585.359a.645.645 0 00-1.157 0L7.377 6.544l-6.824.992a.645.645 0 00-.357 1.1l4.938 4.814-1.166 6.8a.645.645 0 00.936.68l6.1-3.209 6.1 3.209a.645.645 0 00.936-.68l-1.166-6.8 4.939-4.814a.645.645 0 00.17-.662z'
        fill='#fff'
      />
    </svg>
  );
}

export default StarIcon;
